import { CircularProgress, Collapse, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { useData, useStatePtr } from "@pure-ptr/react";
import React, { useContext,useState } from 'react';

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { getPayerDenialsSummary } from "../../store/api/summaryDashboard";
import { asDollarsWithZero } from '../../util/format';
import { DashboardFiltersContext, useClaimAnalysisPage, useStyles } from './Dashboard';
import { nonPaginatedSorting } from '../../util';
import WidgetsSortingComponent from './WidgetsSortingComponent';

export const PayerDenialsWidget = () => {
    
    const classes = useStyles();
    const [sortConfig, setSortConfig] = useState({ key: 'contractName', direction: 'asc' }); 
    const { dateRange } = useContext(DashboardFiltersContext);

    const { data, isPending } = useData( async () => {
        const result = await getPayerDenialsSummary(dateRange.startdate, dateRange.enddate); 
        return result;
    }, [ dateRange ]);

    const openPtr = useStatePtr( {} );

    const handlePayerDenialsRowClick = (key) => {
        openPtr.set((prevState) => ({
            ...prevState, 
            [key]: !prevState[key],
        }));
    }

        const sortableColumns = [
        { key: 'contractName', label: 'Contracts' },
        { key: 'totalClaims', label: 'Count' },
        { key: 'totalAmount', label: 'Amount' },
 
    ];

    const openClaimAnalysis = useClaimAnalysisPage();

    const handlePayerDenialsAmountClick = (contractName, facilityId = null) => {
        sessionStorage.removeItem("duplicated");
        let filters = [
            {
                actualFilter: true, 
                equator: "greater_than", 
                field: "variance", 
                value: 0
            },
            {
                actualFilter: true, 
                equator: "equals", 
                field: "contract.name", 
                value: contractName
            }
        ];

        if(facilityId != null) {
            filters.push({
                actualFilter: true, 
                equator: "equals", 
                field: "facilityId", 
                value: facilityId
            });
        }

        openClaimAnalysis({
            filter: filters,
            customFilter: [
                {
                    customFilter: true, 
                    equator: "greater_than_or_equals_to", 
                    field: "remitdate", 
                    value: dateRange.startdate,
                    relativeFilter:dateRange.relativeFilter
                },
                {
                    customFilter: true, 
                    equator: "less_than_or_equals_to", 
                    field: "remitdate", 
                    value: dateRange.enddate,
                    relativeFilter:dateRange.relativeFilter
                },
                {
                    customFilter: true, 
                    equator: "equals", 
                    field: "isDenial", 
                    value: true
                },
                {
                    customFilter: true, 
                    equator: "equals", 
                    field: "acknowledged", 
                    value: false
                }
            ],
            significance: false,
        });
    }

    const sortedData = React.useMemo(
        () =>
            nonPaginatedSorting([sortConfig], [...(data || [])])
                ?.tableData,
        [data, sortConfig]
    );

    return isPending ? (
        <CircularProgress />
        ) : (
        <Table stickyHeader>
            <TableHead>
            <TableRow key='PayerDenialsHeader'>
                <WidgetsSortingComponent sortableColumns={sortableColumns} sortConfig={sortConfig} setSortConfig={setSortConfig}/>

            </TableRow>
            </TableHead>
            <TableBody>
            {sortedData?.map((entry) => (
                <>
                <TableRow key={entry.contractName} className={entry.payerDenialsByFacilities?.length > 0 ? classes.denialsGroup1Row : ''}>
                    <TableCell sx={{width: "70%"}}>
                        {entry.payerDenialsByFacilities?.length > 0 && (
                            <IconButton sx={{padding: "0 10px 0 0"}} onClick={() => handlePayerDenialsRowClick(entry.contractName)}>
                                {openPtr.value[entry.contractName] ? <ArrowDropDownIcon /> : <ArrowRightIcon />  }
                            </IconButton>
                        )}
                        {entry.contractName}
                    </TableCell>
                    <TableCell sx={{width: "10%"}}><Typography variant="body2">{entry.totalClaims ?? 0}</Typography></TableCell>
                    <TableCell sx={{width: "20%"}}><Typography onClick={()=> handlePayerDenialsAmountClick(entry.contractName)} variant="body2" className={entry.totalAmount ? classes.link : ''}>{entry.totalAmount ? asDollarsWithZero(entry.totalAmount) : 'N/A'}</Typography></TableCell>
                </TableRow>

                {entry.payerDenialsByFacilities?.length > 0 && (
                    <TableRow key={`${entry.contractName}-childRow`}>
                        <TableCell colSpan={3} sx={{padding: "0px", border: 0 }}>
                            <Collapse in={openPtr.value[entry.contractName]} timeout="auto" unmountOnExit>
                            <Table sx={{width: "100%", margin: "0px 0px"}}>
                                <TableBody>
                                {entry.payerDenialsByFacilities?.map((facility, index) => (
                                    <>
                                    <TableRow key={`${entry.contractName}-${index}`}>
                                        <TableCell sx={{width: "10%"}}></TableCell>
                                        <TableCell sx={{width: "60%"}}>{facility?.facilityName ?? "N/A"}</TableCell>
                                        <TableCell sx={{width: "10%"}}><Typography variant="body2">{facility.totalClaims ?? 0}</Typography></TableCell>
                                        <TableCell sx={{width: "20%"}}><Typography onClick={()=> handlePayerDenialsAmountClick(entry.contractName, facility.facilityId ?? "none")} variant="body2" className={facility.totalAmount ? classes.link : ''}>{facility.totalAmount ? asDollarsWithZero(facility.totalAmount) : 'N/A'}</Typography></TableCell>
                                    </TableRow>
                                    </>
                                ))}
                                </TableBody>
                            </Table>
                            </Collapse>
                        </TableCell>
                    </TableRow>
                )}
                
                </>
            ))}
            </TableBody>
        </Table>
    )
}